import { render, staticRenderFns } from "./PrintableDocuments.vue?vue&type=template&id=20d69528&"
import script from "./PrintableDocuments.vue?vue&type=script&lang=ts&"
export * from "./PrintableDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports